import type {
  AutomationRulePreview,
  AutomationRulePreviewChecklistItem,
} from 'hooks/orgEvents/orgEventAutomationHooks';
import type {
  OrgEvent,
  OrgEventChecklistItemInstance,
} from 'hooks/orgEvents/orgEventHooks';

export function impactedResourceIdsFromPreview(
  preview: Pick<AutomationRulePreview, 'resourceChecklists'>
): string[] {
  const lists = preview.resourceChecklists;
  if (!lists) return [];
  const ids = [
    ...lists.assetsWithCoas.map((asset) => asset.resourceSetId),
    ...lists.assetsAtRiskWithoutCoas.map((asset) => asset.resourceSetId),
  ];
  return [...new Set(ids.filter(Boolean))];
}

export function checklistItemsFromPreview(
  items: AutomationRulePreviewChecklistItem[]
): OrgEventChecklistItemInstance[] {
  return items.map((item, index) => {
    if (item.kind === 'send_notification') {
      return {
        kind: 'send_notification',
        id: `preview-notify-${index}`,
        label: item.label,
        notify: {
          notificationTypes: item.channels,
          priority: item.priority,
          titleTemplate: item.title,
          bodyTemplate: item.body,
        },
      };
    }
    return {
      kind: 'org_action',
      actionId: `preview-action-${index}`,
      label: item.label,
    };
  });
}

/** A preview is not persisted, so fake the columns the event card reads. */
export function toSyntheticEvent(preview: AutomationRulePreview): OrgEvent {
  const now = new Date().toISOString();
  return {
    id: 'preview',
    group_guid: '',
    name: preview.event.name,
    type: preview.event.type,
    status: preview.event.status,
    severity: preview.event.severity,
    region: preview.event.region,
    business_unit: null,
    lead: null,
    summary: preview.event.summary,
    resources_committed: preview.resourceCount
      ? `${preview.resourceCount} resource(s)`
      : null,
    lon: preview.event.lon,
    lat: preview.event.lat,
    started_at: now,
    last_update: now,
    creation_kind: 'threshold',
    created_by_user_guid: null,
    threshold_description: preview.event.thresholdDescription,
    demo_key: null,
    archived: false,
    created_at: now,
    updated_at: now,
    impacted_resource_ids: impactedResourceIdsFromPreview(preview),
    triggering_items: preview.triggeringItems ?? [],
    response_checklist_items: checklistItemsFromPreview(preview.checklist),
  };
}
